import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { ShipmentGlobalTrackingMapFacade } from './shipment-global-tracking-map.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentGlobalTrackingMapGuard  {
  constructor(private shipmentGlobalTrackingMapFacade: ShipmentGlobalTrackingMapFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentGlobalTrackingMapFacade);
  }
}
